import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   allOCTDriving,
   deleteOCTDriving,
   fetchOCTDriving,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import EditItem from './component/editform';

class captoreport extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            adddiv:false,
            editdiv:false,
            seldate:'', 
            student:'',
            sepmore:1,
            formValues: [{ clubused:"", right : "", left : "", area:"", contact:"", fairway : "0", missleft : "0", missright : "0", routine : "0"}],
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

   UNSAFE_componentWillMount() {
	   this.props.allOCTDriving();
	}

   onAddSession() {
		this.setState({ 
         student:'',
         viewdiv:false,
         editdiv:false,
         adddiv:true,
      });
   } 
      
   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         viewdiv:true,
       });
	}  


   editAssessment(assmval){
        
      var id=assmval.gocd_userID;
      var date=assmval.gocd_date;
        
        this.props.fetchOCTDriving(id, date).then((data) => {   
         var resdata=data.data;
         var troptobj=[];
         {resdata.map((teamval) => (   
            troptobj.push({
               clubused: teamval.gocd_clubused,
               right: teamval.gocd_right,
               left: teamval.gocd_left,
               area: teamval.gocd_area,
               contact: teamval.gocd_contact,
               fairway: teamval.gocd_fairwayhit,
               missleft: teamval.gocd_missleft,
               missright: teamval.gocd_missright,
               routine: teamval.gocd_routine,
               disright:teamval.gocd_right==0 ? 0 : 1, 
               disleft:teamval.gocd_left==0 ? 0 : 1,
               disfair:teamval.gocd_fairwayhit==0 ? 0 : 1,
               dismsleft:teamval.gocd_missleft==0 ? 0 : 1,
               dismsright:teamval.gocd_missright==0 ? 0 : 1, 
               disroutine:teamval.gocd_routine==0 ? 0 : 1, 
            })
         ))} 
         this.setState({ 
            seldate:resdata[0].gocd_date, 
            student:resdata[0].gocd_userID,
            formValues:troptobj,
            sepmore:resdata.length
         });

            this.setState({ 
                viewdiv:false,               
                adddiv:false,
                editdiv:true,
            });

        });
    }

    deleteForm(assmval){
      this.id = assmval.gocd_userID;
      this.date = assmval.gocd_date;
      this.confirmationDialog.current.openDialog();
    }

   deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteOCTDriving(this.id, this.date);
            this.data = ""
        }
   }

   

    render() {
      const { match, octdrivinglist, loading } = this.props;

      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
      };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
          
        ];
        const tabledata=octdrivinglist.map((assmntval,idx) => {     
               const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
               const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                action: ebtn,
                action1:dbtn,
                
                }
        }); 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>On Course Driving Test | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.oncdriving" />} match={match} />
             
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Test</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                  <EditItem onClick={this.onBackSection} data={this.state}/>              
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'driving test'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ octdriving }) => {
	const { octdrivinglist, loading } = octdriving;
	return { octdrivinglist, loading };
}

export default connect(mapStateToProps, {
   allOCTDriving,
   deleteOCTDriving,
   fetchOCTDriving
})(captoreport); 